module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-HeavyItalic.ed5a3bb.woff2";